import Header from '../Layout/Header';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { dataUser } from '../Helpers/util';
import mixpanel from 'mixpanel-browser';
import Sidebar from "../../Component/Layout/Sidebar";
import CustomHeader from "../../Component/Layout/Header";
import { Layout } from "antd";

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function RewardIframe({ }) {
    const [sos, setSos] = useState();

    useEffect(() => {
        let authToken = JSON.parse(localStorage.getItem('headData'))
        const sosLogin = async () => {
            const param = {
                userId: JSON.stringify(UserObj?.rec_id)
            }
            await axios.post(process.env.REACT_APP_PROD_URL + 'getData/getRewardKartLoginDetails',
                param,
                {
                    headers: {
                        Authorization: authToken?.spintlyToken,
                    }

                }).then(res => {
                    setSos(res.data.redirectionLink)
                }).catch(err => {
                    console.log(err)
                })

        }
        sosLogin();
    }, []);


    const rewardDashClick = () => {
        if (UserObj) {
            mixpanel.track('Bulk Gifting Reward Button', {
                PageName: 'Corporate Gifting',
                UserEmail: UserObj.email,
                UserName: UserObj.fname + ' ' + UserObj.lname,
                UserId: UserObj.rec_id,
                CompanyId: UserObj.company_id,
                CompanyName: UserObj.company_name,
                Type: 'Bulk Gifting Reward Button',
            });
        }
    }

    // Sidebar Toggle
    const [collapsed, setCollapsed] = useState(true); // Sidebar collapsed state
      const toggleCollapsed = () => {
        setCollapsed((prevState) => !prevState);
      };

    return (
        <>
        <Layout>
        
            <Sidebar collapsed={collapsed}/>
            
            <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

            <Layout className={collapsed ? 'no_pad_page PageLayout CollapsedPageLayout' : 'no_pad_page PageLayout'}>
                <div class="PageContent">

                    {/* <div className='RewardIframe_Header d-flex'>
                        <div className='RewardIframe_HeaderLogo mr-auto'>
                            <img src='img/rewardHeaderLogo.png' />
                        </div>
                        <div className='RewardIframe_HeaderSearch'>
                            <div className='position-relative flex-fill'>
                                <input type='text' className='form-control' placeholder='Search Here' />
                                <button type='submit' className='btn'>
                                    <img src="img/search_icon_rewards.svg" />
                                </button>
                            </div>
                            <a className='HowItWorksBTN' href='#'>How it works</a>
                        </div>
                        <div className='RewardIframe_HeaderGiftImg'>
                            <img src='img/rewardHeaderGifts_2.svg' />
                        </div>
                    </div> */}
                    {sos !== undefined &&
                        <div className='WebsiteIframeContainer'>
                            <iframe allow-same-origin src={sos} frameborder="0" id="iframe">...</iframe>
                            <a role='button' href='corporate-gifting' className='RewardHomeFloatBTN RewardHomeFloatBTN_effect' onClick={rewardDashClick}>Reward Dashboard</a>
                        </div>
                    }
                </div>
            </Layout>
        </Layout>
        </>
    );
}
export default connect(
)(RewardIframe);